export default __webpack_public_path__ + "static/media/Asset3_lrg.5eabf27a.png";